/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import { RecoveryPassword } from './components/Recoverypassword'


const AuthLayout = () => {
  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  return (
    <div className='custom-container'>
    <div className='content-container'>
      <div className='row'>
        <div className='col-md-6 col-12 mb-3'>
          <a href='#' className='logo-container'>
            <img alt='Logo' src={toAbsoluteUrl('/media/imgv2/Nube.png')} className='logo-image img-fluid' />
          </a>
        </div>
        <div className='col-md-6 col-12'>
        <div className='custom-content-container text-center'>
          <Outlet />
        </div>
        </div>
      </div>
    </div>
  </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password' element={<RecoveryPassword />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
